import {useQuery} from '@tanstack/react-query';

import {
  getDepositDetails,
  getDepositLogs,
  GetPaymentDetailsParams,
  getPayoutDetails,
  getPayoutLogs,
} from '../api';
import {
  QUERY__DEPOSIT_DETAILS,
  QUERY__DEPOSIT_LOGS,
  QUERY__PAYOUT_DETAILS,
  QUERY__PAYOUT_LOGS,
} from '../queryKeys';

interface Options {
  enabled?: boolean;
}

export const useGetDepositDetails = (
  params: GetPaymentDetailsParams,
  options?: Options,
) =>
  useQuery({
    queryKey: [QUERY__DEPOSIT_DETAILS, params],
    queryFn: () => getDepositDetails(params),
    ...options,
  });

export const useGetDepositLogs = (
  params: GetPaymentDetailsParams,
  options?: Options,
) =>
  useQuery({
    queryKey: [QUERY__DEPOSIT_LOGS, params],
    queryFn: () => getDepositLogs(params),
    ...options,
  });

export const useGetPayoutDetails = (
  params: GetPaymentDetailsParams,
  options?: Options,
) =>
  useQuery({
    queryKey: [QUERY__PAYOUT_DETAILS, params],
    queryFn: () => getPayoutDetails(params),
    ...options,
  });

export const useGetPayoutLogs = (
  params: GetPaymentDetailsParams,
  options?: Options,
) =>
  useQuery({
    queryKey: [QUERY__PAYOUT_LOGS, params],
    queryFn: () => getPayoutLogs(params),
    ...options,
  });
